import { AxiosResponse } from "axios";
import { axiosInstanceV1 } from "./axiosInstance";

/*
	Portal del alumno (Fase 1, 2026-10-16). Todas las rutas son /scholar/_*: el servidor toma al alumno
	de la sesión, el cliente nunca manda un id de alumno.
*/
export interface ClaseDelAlumno
{
	enrollmentId: number
	scheduleId: number
	date: string
	dayName: string
	dayNumber: number
	startLabel: string
	endLabel: string
	course: string
	level: string
	/** Period name ("Septiembre 2026"), shown under the course. */
	period?: string | null
	mentor: string | null
	campus: string | null
	state: "live" | "upcoming" | "finished" | null
	minutesSinceStart: number | null
	/** El horario es del plantel Online y tiene aula virtual. */
	hasAula: boolean
	/** Publicaciones del portal de la clase que el alumno aún no ve (punto naranja). */
	lmsNew?: number
	/** Solo en las clases de hoy con aula: ventana de entrada en milisegundos (hora del servidor). */
	aula: { opensAtMs: number; opensLabel: string; startsAtMs: number; closesAtMs: number } | null
}

export interface MontoVencido { currency: string; symbol: string; amount: number }

export interface CuentaDelAlumno
{
	hasOverdue: boolean
	overdue: MontoVencido[]
	oldestOverdue: { title: string; dueDate: string; dueLabel: string } | null
	nextDueDate: string | null
	nextDueLabel: string | null
	/** Saldo vencido sin pase: no puede entrar al aula. Un pago en revisión NO lo desbloquea. */
	blocksAula: boolean
	pass: { untilMs: number; untilLabel: string } | null
}

export interface ReporteDePago
{
	id: number
	status: "review" | "applied" | "rejected"
	statusLabel: string
	amount: number | null
	createdAt: string | null
	createdLabel: string | null
}

export interface MisClasesDTO
{
	student: { name: string; code: string | null }
	now: string
	serverNowMs: number
	classes: { today: ClaseDelAlumno[]; week: ClaseDelAlumno[]; mine?: { scheduleId: number; course: string; level: string; period?: string | null; mentor: string | null; lmsNew: number }[] }
	account: CuentaDelAlumno
	attendance: { present: number; total: number }
	reports: ReporteDePago[]
}

export interface AsistenciaCurso
{
	enrollmentId: number
	course: string
	level: string
	period?: string | null
	present: number
	total: number
	items: { date: string; label: string; present: boolean }[]
}

export interface MensualidadDelAlumno
{
	id: number
	title: string
	dueDate: string
	dueLabel: string
	amount: number
	paid: number
	balance: number
	currency: string
	symbol: string
	status: "paid" | "overdue" | "pending"
	statusLabel: string
}

export class PortalAlumnoService
{
	joinClass = async (scheduleId: number): Promise<AxiosResponse<{ url: string }>> => axiosInstanceV1.post<{ url: string }>("/scholar/_join/" + scheduleId)
	classes = async (): Promise<AxiosResponse<MisClasesDTO>> => axiosInstanceV1.get<MisClasesDTO>("/scholar/_classes")
	attendances = async (): Promise<AxiosResponse<{ courses: AsistenciaCurso[] }>> => axiosInstanceV1.get("/scholar/_attendances")
	statement = async (): Promise<AxiosResponse<{ account: CuentaDelAlumno; tuitions: MensualidadDelAlumno[] }>> => axiosInstanceV1.get("/scholar/_statement")
	reports = async (): Promise<AxiosResponse<{ reports: ReporteDePago[] }>> => axiosInstanceV1.get("/scholar/_payReports")
	reportPayment = async (motivo: string, files: File[], onProgress?: (porcentaje: number) => void): Promise<AxiosResponse<{ folio: number }>> =>
	{
		const form = new FormData()
		form.append("motivo", motivo)
		files.forEach((f) => form.append("files[]", f, f.name))
		return axiosInstanceV1.post<{ folio: number }>("/scholar/_payReport", form,
		{
			timeout: 180000,
			headers: { Accept: "application/json" },
			onUploadProgress: (p) => { if (onProgress && p.total) onProgress(Math.round((p.loaded / p.total) * 100)) }
		})
	}
}

const portalAlumnoService = new PortalAlumnoService()
export default portalAlumnoService
